export const SAVE_SETTINGS = 'SAVE_SETTINGS'
export const FETCH_EXCHANGE_RATE = 'FETCH_EXCHANGE_RATE'
